module.exports = __webpack_public_path__ + "img/a1.80ebbce2.jpg";